// extracted by mini-css-extract-plugin
module.exports = {"input":"Editions_input__is3Hx"};